import eventbus from '@app/eventbus'
import noty from '@lib/noty'
import {date} from '@lib/date'
import dlg from '@app/dlg'
import {flags as apiFlag} from '@app/api'

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!     
// !!     This class is created as part of a case and not completely finished. 
// !!     Eventually it will be replacing the current dialog / model structure. 
// !!     As such, it is prepared for dirty checking. The same mechanism can be used for 
// !!     temporary snapshots which can be used for users keeping their session open too long. 
// !!     Also, the dirty check can be used to ask confirmation when closing a dialog with unsaved changes.
// !!     
// !!     Open issues: 
// !!     - rights checking on open a la clsModel(Base). 
// !!     - implementation of 'disabled', based on the rights and the state of the model. - a la clsModel(Base).
// !!     
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


/**
 * In the beginning, we envisioned strong seperation of concerns between the model and the dialog. 
 * The model would be responsible for all data handling, loading, saving, etc. 
 * The dialog would be responsible for the presentation and user interaction. 
 * However, in practice, we see that models and dialogs are strongly interconnected. For example, a model may need knowledge about 
 * its 'dialog open' state for deciding it needs to refresh its data. 
 * 
 * Considering that: 
 *   - 95% of the models are used in dialogs, 
 *   - it is confusing that the dialog has an 'id' on which it registers the event handler for opening, 
 *     AND the model has an id, which is used for task authorization,
 *   - in many cases the state of the dialog is significant knowledge for the model
 *     (e.g. refresh data ONLY when the dialog or the tab is active)
 *   - In the other 5% of the cases, the model is a custom model anyways,
 * 
 * ... we have decided to bring the dialog - and data model together in one class. 
 * 
 * Implementation notes: 
 * - setKeyOnOpen property. 
 *   Vue typically reuses the DOM as efficiently as possible. 
 *   That is fine. But in case of dialogs, it means that once the dialog opened, and the components are mounted, the creation is finished.
 *   When the dialog is closed, it is moved to shadow dom and when it is reopened, it is moved to DOM. 
 *   This without going through the lifecycle again. 
 * 
 *   In most cases this is perfectly fine, except when components used in the dialog must e.g. load new data on mount. 
 *   Specificly, this is about datatable. 
 *   When a dialog contains a datatable somewhere, e.g. addresses for a relation, the datatable is loaded once, and not again
 *   when the dialog is reopened for another relation. This is problematic as wrong addresses are shown. 
 * 
 *   In this case, you can force the dialog to go through all lifecycles by setting the 'setKeyOnOpen' property to true in the dialog 
 *   construction options. 
 * 
 *********************************************************************************************
 * Use cases. 
 *********************************************************************************************
 * 
 * 1. A dialog with a simple form. 
 *    A dialog is started where the user can fill in some data and return the data to the dialog 'caller'. 
 *    No server interaction. Concrete example: DialogCreateOrder in tenders.
 *    The caller of the dialog closes it when its transaction is finished.
 * 
 *      Step 1 -- define an action and define which modules and rights are required to execute this action. 
 *         We name the action the same as the model.          
 * 
 *          in actions.2.js: 
 *            "tender_createorder": { 
 *              open:           { modules: [m.SALESORDERS], rights: [r.salesorder_create], icon: 'order',   text: "Maak order"  },
 *              modify:         { modules: [m.SALESORDERS], rights: [r.salesorder_create], icon: 'order',   text: "maak order"  },
 *            },
 *
 *     var dlgOptions = await eventbus.dialog.open('tender_createorder', {tender: model});
 *     var fnCreateOrder = async (dlgOptions) => {
 *         if (!await noty.tryConfirm("Weet u zeker dat u de order wilt aanmaken?")) {
 *               return;
 *         }
 *         var result = await model.createOrder(createOptions);
 *         dlgOptions.close();
 *     }
 *
 *     dlgOptions.hookSaved(fnCreateOrder);
 *
 ****************************************************************************************************************
 * 2. A dialog which is responsible for loading and saving its own data.
 * 
 *      Step 1 -- define an action and define which modules and rights are required to execute this action. 
 *         We name the action the same as the model.          
 * 
 *          in actions.2.js: 
 *              "unit": {
 *                  open:   { modules: [m.TENDERS, m.SALESINVOICES, m.PROJECTS], rights: [r.unit_access], icon: 'open',   text: "Open eenheid"}, 
 *                  modify: { modules: [m.TENDERS, m.SALESINVOICES, m.PROJECTS], rights: [r.unit_modify], },
 *                  .....
 *            },
 *
 *     var dlgUnit = await eventbus.dialog.open('unit', {id: 1234});
 *     if (!await dlgUnit.promiseClosed()) {
 *          return; 
 *     }
 *     fnRefreshStatistics(); // Or any other action which needs to be done after the dialog is closed with save.
 * 
 *********************************************************************************************
 * Implementation cases
 *********************************************************************************************
 *
 * See: 
 *    DialogTender, onCreateOrder. 
 *    It opens: \features\tender\tender\dialog\DialogModelCreateOrder.vue
 * 
 */


class clsDialogModel {

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  The methods which typically are implemented in a dialog model. 
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // Apply the changes. Does not change the dialog state.
    async save(data) {
        throw new Error("save method must be implemented in the dialog model");
    }
    async load(params, extraData) {
        throw new Error("load method must be implemented in the dialog model");
    }
    // Implement create to return data which is the default data for a new instance of the model.
    async create(params, extraData) {
        return 
    }
    // The representation of the current model. 
    // Implement when significant. E.g. return 'this.invoice_number';
    get rep() {
        return null; 
    }

    // Override fill to implement custom filling of the model or setting defaults before fill..
    //    fill(data) {
    //        data = data || {};
    //        data.boolie = !!data.boolie; 
    //        return super.fill(data); 
    //    }


    // Override validate to implement custom validation.
    //     async validate() {
    //        if (!super.validate()) {
    //            return false;
    //        } 
    //        return await this.handleWarnings(); 
    //     }

    // Override toJSON to create custom implementation or add properties to the JSON.
    //     toJSON() {
    //        var result = super.toJSON();
    //        result.myprop = this.calculateMyProp();
    //        return result;
    //     }


    ////////////////////////////////////////////////////////////////////////////////////////////////////

    id              = null; // Id of the entity - whenever applicable.  
    flag            = null; // The current value of the flag 
    noteCount       = null; // The current value of the note 
    attachmentCount = null; // The current value of the attachmentcount 
    
    // Dialog state
    // getters and setters, so that the behavior of those properties can be 'customized' by overriding the getters.
    _isOpen       = false;     get isOpen()          { return this._isOpen;          } set isOpen(v)          { this._isOpen = v;       }
    _tab          = 0;         get tab()             { return this._tab;             } set tab(v)             { this._tab = v;          } // Whenever tabs are used, bind the tab to this property.
    _isLoading    = false;     get isLoading()       { return this._isLoading;       } set isLoading(v)       { this._isLoading = v;    }
    _isFilling    = false;     get isFilling()       { return this._isFilling;       } set isFilling(v)       { this._isFilling = v;    }
    _setKeyOnOpen = false;     get setKeyOnOpen()    { return this._setKeyOnOpen;    } set setKeyOnOpen(v)    { this._setKeyOnOpen = v; }
    _dlgKey       = undefined; get dlgKey()          { return this._dlgKey;          } set dlgKey(v)          { this._dlgKey = v;       }    
    _icon         = null;      get icon()            { return this._icon;            } set icon(v)            { this._icon = v;         }
    _noSubTitle   = false;     get noSubTitle()      { return this._noSubTitle;      } set noSubTitle(v)      { this._noSubTitle = v;   }
    _noActions    = false;     get noActions()       { return this._noActions;       } set noActions(v)       { this._noActions = v;    }
    _saveText     = false;     get saveText()        { return this._saveText;        } set saveText(v)        { this._saveText = v;     }
    _cancelText   = false;     get cancelText()      { return this._cancelText;      } set cancelText(v)      { this._cancelText = v;   }
    _keepOpen     = false;     get keepOpen()        { return this._keepOpen;        } set keepOpen  (v)      { this._keepOpen = v;   }
    _forms        = [];        get forms()           { return this._forms;           } set forms(v)           { this._forms = v;        }
    _fillable     = [];        get fillable()        { return this._fillable;        } set fillable(v)        { this._fillable = v;     }

    _id_optimit_type  = false; get id_optimit_type() { return this._id_optimit_type; } set id_optimit_type(v) { this._id_optimit_type = v;   }
    _noteType         = false; get noteType()        { return this._noteType;        } set noteType(v)        { this._noteType = v;   }
    _flagType         = false; get flagType()        { return this._flagType;        } set flagType(v)        { this._flagType = v;   }
    _attachmentType   = false; get attachmentType()  { return this._attachmentType;  } set attachmentType(v)  { this._attachmentType = v;   }

    _modelName        = null;  get modelName()       { return this._modelName;       } set modelName(v)       { this._modelName = v;   }
    _dlgTitle         = null;  get dlgTitle()           { return this._dlgTitle;     } set dlgTitle(v)           { this._dlgTitle = v;   }

    // When closing while changes have been made, ask confirmation first.
    _useDirtyCheck    = null;  get useDirtyCheck()           { return this._useDirtyCheck;           } set useDirtyCheck(v)           { this._useDirtyCheck = v;   }

    // The getter for the class returns the standard dialog class as well.
    _cls              = null;  get cls()             { return `${this._cls} dialog-${this.modelName}`; } set cls(v) { this._cls = v; }

    // isOpen is in fact the one state which truely matters for a dialog. The dialog is open or not open. 
    // When opened, we do some cleanup for hooks and promises which might be dangling from preious openings.
    _isOpen = false; get isOpen() { return this._isOpen; } 
    set isOpen(v) { 
        if (!this._isOpen && v) {
            this._resetValidation();
            this._cleanupPromises();
            this._cleanupHooks(); 
        }
        this._isOpen = v;
    }


    // {
    //    name:  "tender",
    //    title: "Offerte",
    //    forms: [ref1, ref2],     // optional: when specified, these forms are validated before saving.]
    //    cls:   'my-dialog-class' // optional: a class which is attached to the dialog for styling purposes.
    //    icon: 'order',           // optional
    // }
    constructor(options) {

        this.modelName  = options.modelName;
        this.dlgTitle = options.dlgTitle || "";
        this.forms = !options.forms ? [] : (Array.isArray(options.forms) ? options.forms : [options.forms]);
        this.cls  = options.cls   || "";
        this.icon = options.icon; // undefined is fine as a value for the icon.
        this.setKeyOnOpen = options.setKeyOnOpen || false;
        this.noSubTitle = !!options.noSubTitle;
        this.noActions = !!options.noActions;
        this.saveText = (undefined === options.saveText) ? "Opslaan" : options.saveText;
        this.cancelText = (undefined === options.cancelText) ? "Annuleren" : options.cancelText;
        this.useDirtyCheck = !!options.useDirtyCheck;
        this.keepOpen = !!options.keepOpen;

        this.id_optimit_type = options.id_optimit_type;
        this.noteType = options.noteType;
        this.flagType = options.flagType;
        this.attachmentType = options.attachmentType;

        this.setUniqueDialogKey();
        this.registerEvents();

    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Validation
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
     * When forms are specified, reset their validation.
     */
    _resetValidation() {
        for (var n = 0; n < (this.forms||[]).length; n++) {
            var form = this.forms[n]
            if (form && form.value) {
                form = form.value;
            }
            if (form._resetValidation) {
                form._resetValidation();
            }
        }
    }

    // Basic forms validation.
    // Override this method and call super.validate() when you want to add custom validation on top of the basic forms validation. 
    // 
    async validate() {
        for (var n = 0; n < (this.forms||[]).length; n++) {
            var form = this.forms[n]
            if (form && form.value) {
                form = form.value;
            }
            if (form && form.validate) {
                if (!form.validate()) {
                    this.tab = n; 
                    return false;
                }
            }
        }
        return true;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Promises
    //
    // Note that promises should not be reactive. 
    // As such, those properties are added dynamically to the object (this) and only when used.
    // 
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    
    // closed promise. This promise is resolved when the dialog is closed, and returns the result of the dialog. 
    // The whole point of this promise is waiting for the dialog to be closed via either save or cancel. 
    // returns: 
    //    false when the dialog is canceled,
    //    true when the dialog is saved and closed. 
    // 
    // In both cases, after the promise is resolved, the object (which is an instance of the dialog model) is still available, 
    // so that the caller can retrieve any data from the model after the dialog is closed.
    // Private members.
    #promiseClosed = {
        promise: null,
        resolve: null, 
        settled: false
    };
    resolvePromiseClosed(value) {
        // Only when we have a promise - that is, someone is waiting for the promise, which was obtained via the closed() method, resolve it.
        if (!this.#promiseClosed.promise) {
            return; // no promise 
        }

        if (this.#promiseClosed.settled) {
            return; // Already done.
        }

        this.#promiseClosed.resolve(value);
        this.#promiseClosed.settled = true;
    }

    // When we already have a promise, resolve it first, before setting it to null.
    // in any - erroneous - case a process is listening, the process is not blocked forever.
    _cleanupPromises() {

        // When the promise is still open, resolve it.
        this.resolvePromiseClosed(false); 
        this.#promiseClosed.promise = null;
        this.#promiseClosed.resolve = null;
        this.#promiseClosed.settled = false;
    }

    // The caller can call this method to get a promise which is resolved when the dialog is closed.
    // When the dialog is closed via the onSave method, the promise is resolved with true. 
    // When the dialog is closed via the onCancel method, the promise is resolved with false.
    promiseClosed() {
        if (!this.#promiseClosed.promise) {
            this.#promiseClosed.promise = new Promise((resolve, reject) => {
                this.#promiseClosed.resolve = resolve;
            });
        }
        return this.#promiseClosed.promise;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Hooks aka callbacks. 
    // 
    // Typically, an opener of a dialog is interested in whether the dialog was closed via save or cancel, 
    // so that it can decide whether to refresh the data or not. 
    // In case when multiple save actions are possible, e.g. when the dialog is a data provider and the caller 
    // controls opening and closing the dialog, this can be used.
    // 
    // BUT: in general cases, the preferred way is using the promiseClosed method, as it is more explicit and easier to understand. 
    //
    // Note that hooks should not be reactive. 
    // As such, those properties are added dynamically to the object (this) and only when used.
    // 
    ////////////////////////////////////////////////////////////////////////////////////////////////////

    // Internal method to cleanup hooks. Calles when the dialog is opened.
    #hooksSaved = [];
    _cleanupHooks() {
        if (this.#hooksSaved) {
            this.#hooksSaved = [];
        }
    }
    // Trigger the saved hooks.
    _triggerHooksSaved() {
        console.log('_triggerHooksSaved', this.#hooksSaved)
        if (this.#hooksSaved) {
            this.#hooksSaved.forEach(fnCallback => fnCallback(this));
        }
    }
    // Hook a callback to the save event.
    hookSaved(fnCallback) {
        if (!this.#hooksSaved) {
            this.#hooksSaved = [];
        }
        this.#hooksSaved.push(fnCallback);
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // JSON / Serialization
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // Convert the given properties to a value which can be used in JSON. 
    // E.g. convert dates to ISO string, use toJSON when available, etcetera.
    prop2JsonableValue(prop) {
        if (!prop) {
            return null;
        }
        var value = this[prop];
        if (value === null) {
            return null;
        }            
        if (value === undefined) {
            return undefined;
        }                    
        if (value && typeof value.toJSON === 'function') {
            return value.toJSON();
        }
        if (value && typeof value.getFullYear === 'function') { // Date
            return date.fmt.iso(value);
        }
        if (value === 0 || value === "0") {
            return "0";
        }
        // Prevent empty string to be converted to 0.
        if (value === "") {
            return "";
        }
        // When the value is an array and the array items have a toJSON function, use the toJSON function of the items.
        // otherwise, simply return the array as is.
        if (Array.isArray(value)) {
            return value.map( (item) => {
                if (item && typeof item.toJSON === 'function') {
                    return item.toJSON();
                }
                return item;
            })
        }

        // Make sure that true, "true", 1 and "1" match. Same for false.
        // Same for "1" vs 1 and "12345" va 12345. 
        if (!isNaN(Number(value))) {
            return `${Number(value)}`;
        }
        // Otherwise, just return the value.
        return value;
    }

    /**
     * Convert this object to JSON
     * Override when required. 
     * Example implementation: 
     *           return this.propsToJSON(["id","name","rights"])
     * @returns 
     */
    toJSON() {
        if (!this.fillable) {
            console.error("clsModel - toJSON must be overridden when fillable is not specified");
            return {};    
        }
        var arrProps = ['id', ...this.fillable];
        let result = {};
        (arrProps || []).forEach(  ( prop ) => { 
            result[prop] = this.prop2JsonableValue(prop);
        })        
        return result;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Dirty checks
    // Note that the snapshot used for dirty check is not supposed to be reactive and therefore is 
    // not part of the default data of the model. It is created when necesary.
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    #snapshot = null; // The snapshot used for dirty check. When useDirtyCheck is false, this is not used.
    serialize() {
        return JSON.stringify(this.toJSON());        
    }
    storeSnapshot() {
        if (this.useDirtyCheck) {
            this.#snapshot = this.serialize();
        }        
    }
    isSnapshotDirty() {
        if (!this.useDirtyCheck) {
            return false;
        }

        var currentState = this.serialize();
        return currentState != this.#snapshot;
    }
    clearSnapshot() {
        this.#snapshot = null;
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Flag / Note / Attachment functionallity
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////

    // Set the flag value.
    // When the model is new, save it first.
    async setFlagValue (value) {
        if (this.isNew) {
            if (!await this.apply()) {
                this.flag = null;
                return;
            }
        }

        let result = await apiFlag.save(value, this.id_optimit_type, this.id);
        this.flag = result.data.value;
        eventbus.model.saved('flag', {id_entity: this.id, flagType: this.flagType, flag: value});
    }
    // open the note dialog. When new, save the model first.
    async onNote() {
        if (this.model.isNew) {
            if (!await this.apply()) {
                return;
            }
        }
        var result = await dlg.promised.tryOpen('note', this.model, {rightsModelName: this.noteType}) 
        if (false == result) {
            return;
        }
        this.noteCount = (!!result.note) ? 1 : 0;
    }
    async onAttachment() {
        if (this.model.isNew) {
            if (!await this.apply()) {
                return;
            } 
        }
        var result = await dlg.promised.tryOpen('attachments', this.model, {rightsModelName: this.attachmentType}) 
        if (false == result) {
            return;
        }
        this.attachmentCount = result.count;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Dialog state and behavior
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    async close(bSaved) {
        this.isOpen = false;        
        this.resolvePromiseClosed(!!bSaved)
    }
    async apply() {
        return await this.setLoadingWhile( async () => {

            // Validate. When validation fails, do not proceed with saving. 
            if (!await this.validate()) {
                return false;
            }

            let data = this.toJSON();

            await this.save(data); // save is overwritten. It is up to the implementation of the dialog model whether 
                                // it changes the data or not. E.g. a specific model can use this.fill(data); after save.

            // When any hooks for save are registered, trigger them.
            this._triggerHooksSaved(); 
            // Send the saved event.
            this.sendSavedEvent();
            // Now that the data is saved, the hooks are triggered and the events are sent, update the dirty check snapshot. 
            this.storeSnapshot();  

            return true;
        });
    }
    // Save the data and close the dialog when successful.
    // When the 
    async onSave() {
        if (!await this.apply()) {
            return;
        } 
        if (this.keepOpen) {
            return;
        }
        // When apply succeeds, we can close 
        this.close(true);
    }
    
    // Close the dialog.
    // When the dialog is dirty, ask confirmation first.
    async onCancel() {
        if (!await this.canClose()) {
            return;
        }
        this.close(false);
    }

    // icon. Defaults to modelname if not specified. 
    // When icon property is explicitely set to null, no icon.
    get icon() {
        if (this._icon === null) {
            return null;
        }
        return this._icon || this.name;
    }

    // :TODO:
    get disabled() {
        return false;
    }
    // Is the model new? Considered new when no id is set.
    get isNew() {
        return !this.id;
    }

    /**
     * Get the title. Overload the titleRep getter to implement the title.
     */
     get subTitle() {
        if (this.isLoading) {
            return 'Laden...';
        }
        if (this.isNew) {
            return 'Nieuw';
        }
        if (this.rep) {
            return this.rep;
        } 
        if (this.disabled) {
            return '';
        }
        return 'Wijzig';
    }

    //
    // Generate a unique dialog key. When the dialog must re-create child controls after open, 
    // set it to true. For example when the dialog contains child-list tabs.
    setUniqueDialogKey() {
        if (!window._kdlg) {
            window._kdlg = 1;
        }
        window._kdlg++;
        this._dlgKey = window._kdlg + 1;
    }

    // Opens the dialog, loads the data and fills the model. 
    // Also makes sure the dialog goes through the lifecycle, which is important when the dialog contains dynamic components like datatables.
    // In addition, the initial state is stored for dirty check purposes when enabled.
    async onOpen(params, extraData) {
        // When the dialog needs to be re-initialized qua vue bindings, set a unique key anytime it opens. 
        // This is necesary when dynamic parts - like datatables - are part of the dialog. The must refresh 
        // when opening another model in the dialog.
        if (this._setKeyOnOpen) {
            this.setUniqueDialogKey();
        }
        this.isOpen = true;
        try {
            await this.loadAndFill(params, extraData);
        }
        catch (err) {
            this.close();
            throw err;
        }
    }

    /**
     * Load and fill the data. 
     * 
     * When a reload is required, use this method as well as it makes sure the loading state is 
     * set correctly and the snapshot is stored for dirty check purposes.
     * @param {} params 
     * @param {*} extraData 
     */
    async loadAndFill(params, extraData) {
        await this.setLoadingWhile( async () => {
            var data = await this.load(params, extraData);
            this.fill(data);
        });
        this.storeSnapshot(); 
    }

    // onCopy has still to be implemented. 
    // To do on first implementation.
    async onCopy(params) {
        throw new Error("Copying is not implemented yet in this dialog model");
    }

    // 'Hard' close the dialog.
    // As for now, hard close it. 
    async onClose(params) {
        this.close(false);
    }

    async onCreate(params, extraData) {
        // When the dialog needs to be re-initialized qua vue bindings, set a unique key anytime it opens. 
        // This is necesary when dynamic parts - like datatables - are part of the dialog. The must refresh 
        // when opening another model in the dialog.
        if (this._setKeyOnOpen) {
            this.setUniqueDialogKey();
        }
        this.isOpen = true;
        try {

            await this.setLoadingWhile( async () => {
                var data = await this.create(params, extraData) || {};
                this.fill(data);
            });
            this.storeSnapshot(); 
        }
        catch (err) {
            this.close();
            throw err;
        }
    }

    async canClose() {
        if (!this.useDirtyCheck) {
            return true;
        }
        if (!this.isSnapshotDirty()) {
            return true; // Fine, not dirty
        }

        if (!await noty.tryConfirm("Er zijn wijzigingen die nog niet zijn opgeslagen. Weet u zeker dat u dit venster wilt sluiten?", {labelConfirm: "Ja, sluit venster", cancel: "Annuleren"}) ) {
            return false; 
        }
        return true;
    }
    
    onKeyDown(evt, b, c) {
        if (evt && evt.key == "Escape") {
            this.onCancel()
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Model methods 
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////

    // Fill one field. Overwrite when complex behavior or sanitation is required on field level.     
    fillField(fieldName, fieldValue) {
        this[fieldName] = fieldValue;
    }

    /**
     * Overwrite and call super when input data needs sanitation first. 
     * 
     * @param {*} data 
     */
    fill(data) {
        this.isFilling = true;

        data = data ||{};
        try {
            // Default not provided data to null.
            (this.fillable||[]).forEach( (field) => {
                if (undefined == data[field]) {
                    data[field] = null;
                }
            })
            var self = this;
            (['id', 'flag', 'noteCount', 'attachmentCount', ...(this.fillable||[])]).forEach( (field) => {
                self.fillField(field, data[field]);
            })

            return data;
        }
        finally {
            this.isFilling = false;
        }
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Outgoing Events
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    sendSavedEvent() {
        eventbus.model.saved(this.modelName, this);
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Event handling
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    // Overridables
    async onBeforeOpen(params, extraData) {}
    async onBeforeCreate(params, extraData) {}
    async onBeforeCopy(params, extraData) {}
    async onBeforeClose(params, extraData) {}


    async onEventOpen(params, extraData) {
        await this.onBeforeOpen(params, extraData);
        await this.onOpen(params, extraData);        
    }
    async onEventCreate(params, extraData) {
        await this.onBeforeCreate(params, extraData);
        await this.onCreate(params, extraData);        
    }
    async onEventCopy(params, extraData) {
        await this.onBeforeCopy(params, extraData);
        await this.onCopy(params, extraData);        
    }
    async onEventClose(params, extraData) {
        await this.onBeforeClose(params, extraData);
        await this.onClose(params, extraData);        
    }

    evtRegistrations = []
    
    registerEvents() {
        var self = this;

        this.evtRegistrations.push(

            eventbus.dialog.open.on( async (modelName, params, extraData) => {
                if (modelName == self.modelName) {
                    await this.onEventOpen(params, extraData); 
                    return self;  // The caller receives our handle. 
                }         
            })

        )

        this.evtRegistrations.push(

            eventbus.dialog.create.on( async (modelName, params, extraData) => {
                console.log('eventbus.dialog.create.on', modelName, self.modelName);
                if (modelName == self.modelName) {
                    await this.onEventCreate(params, extraData); 
                    return self;  // The caller receives our handle. 
                }         
            })

        )
        this.evtRegistrations.push(
            eventbus.dialog.copy.on( async (modelName, params, extraData) => {
                if (modelName == self.modelName) {
                    await this.onEventCopy(); 
                    return self;  // The caller receives our handle. 
                }         
            })
        )

        this.evtRegistrations.push(
            eventbus.dialog.close.on( async (modelName, params, extraData) => {
                if (modelName == 'all' || (modelName == self.modelName)) {
                    await this.onEventClose();
                    // Do not return the current instance.
                }         
            })
        )
        // Get an instance of a currently open dialog. 
        // This is specificly for development testing. 
        this.evtRegistrations.push(
            eventbus.dialog.ga.on((modelName) => {
                if (!self.isOpen) {
                    return;
                }
                if (!modelName || modelName == self.modelName) {
                    return self;
                }
            })
        )
    }
    cleanUp() {
        (this.evtRegistrations||[]).forEach( (fnUnRegister) => fnUnRegister() ) 
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Utilities
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    get ruleMandatory() { return [ (v) => (Array.isArray(v) ? (v&&!!v.length) : !!v) || "Veld is verplicht" ]; }

    // Set the state to loading while the given function is running.
    async setLoadingWhile(fn) {
        var result = null;
        try {
            this.isLoading = true;
            result = await fn();
        }
        finally {
            this.isLoading = false;
        }
        return result;
    }
}

export default clsDialogModel;